import create from 'zustand';
import { persist } from 'zustand/middleware';

interface DriverInfo {
  name: string;
  medio: string;
  telefono: string;
  email: string;
  genero: string;
  fechaNacimiento: any;
  codigoPostal: string;
  numCotizacion: string;
  emailCotizacion: string;
  recaptcha: string;
  coppelEmployeeId: string;
}

interface Driver {
  driver: DriverInfo;
  setDriver: (driver: DriverInfo) => void;
  initialDriver: DriverInfo;
  resetDriver: (driver: DriverInfo) => void;
}

export const initialDriver = {
  name: '',
  medio: '',
  telefono: '',
  email: '',
  genero: '',
  fechaNacimiento: null,
  codigoPostal: '',
  numCotizacion: '',
  emailCotizacion: '',
  recaptcha: '',
  coppelEmployeeId: '',
}

export const useDriverStore = create<Driver>(
  //@ts-ignore
  persist(
    (set) => ({
      driver: {
        name: '',
        medio: '',
        telefono: '',
        email: '',
        genero: '',
        fechaNacimiento: null,
        codigoPostal: '',
        numCotizacion: '',
        emailCotizacion: '',
        recaptcha: '',
        coppelEmployeeId: '',
      },
      setDriver: (driver) => {
        set({ driver });
      },
      resetDriver: (initialDriver) => {
        set({initialDriver});
      }
    }),
    {
      name: 'driverInfo-storate',
      getStorage: () => sessionStorage,
    }
  )
);
